import BackendService from './BackendService';

export default class BYOService {
  static importSubaruData(websiteId: string) {
    return BackendService.post(`/byo/websites/${websiteId}/imports`);
  }
  static linkBYOInventory(websiteId: string) {
    return BackendService.post('/byo/inventory-linking', {
      body: { websiteId },
    });
  }
}
